import { render, staticRenderFns } from "./userSmallCard.vue?vue&type=template&id=6db4936f"
import script from "./userSmallCard.vue?vue&type=script&lang=js"
export * from "./userSmallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports